module.exports = __webpack_public_path__ + "img/40_38_071_510.e57220cb.jpg";